import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import PartnerAccessFrequencyTable from './PartnerAccessFrequencyTable';
import { PartnerAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';
import { get } from 'lodash';

class PartnerAccessFrequencyDetailTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerAccessFrequencyListService.load();
  }

  render() {
    return (
      <PartnerAccessFrequencyTable
        loading={
          PartnerAccessFrequencyListService.fetchCurrent.fetching ||
          PartnerAccessFrequencyListService.fetchPrevious.fetching
        }
        values={toJS(PartnerAccessFrequencyListService.getCompaniesByType(this.props.type, this.props.typeId))}
        feedbackColorRender={PartnerAccessFrequencyListService.getFeedbackColor}
        onSelect={(row) =>
          browserHistory.push(
            `/kpis/customer-success/${this.props.type}/${get(this.props, 'typeId', 'NA')}/company/${row.id}/details`
          )
        }
        formatter={PartnerAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerAccessFrequencyDetailTableContainer);
